'use client'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { Icon } from '@/components/Icons'

const LINKS = [
  { href: '/', label: 'Home' },
  { href: '/tennisschool-software', label: 'Functies' },
  { href: '/pricing', label: 'Prijzen' },
  { href: '/contact', label: 'Contact' },
]

export function Topbar() {
  const pathname = usePathname()
  const [open, setOpen] = useState(false)

  // Voorkom scrollen van de achtergrond terwijl het menu open is.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  return (
    <header className="topbar">
      <div className="container topbar-inner">
        <Link href="/" className="logo">
          <div className="logo-mark">S</div>
          <div className="logo-text">Servd</div>
        </Link>
        <nav className="nav">
          {LINKS.map(l => (
            <Link
              key={l.href}
              href={l.href}
              className={`nav-link ${pathname === l.href ? 'active' : ''}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="nav-meta">
          <Link href="/contact?subject=trial" className="btn btn-primary btn-sm">Gratis testen</Link>
        </div>
        <button
          type="button"
          className="nav-toggle"
          aria-label={open ? 'Menu sluiten' : 'Menu openen'}
          aria-expanded={open}
          aria-controls="mobile-menu"
          onClick={() => setOpen(o => !o)}
        >
          {open ? <Icon.X size={22} /> : <Icon.Menu size={22} />}
        </button>
      </div>

      {open && (
        <div id="mobile-menu" className="mobile-menu">
          <nav className="mobile-menu-nav">
            {LINKS.map(l => (
              <Link
                key={l.href}
                href={l.href}
                className={`mobile-menu-link ${pathname === l.href ? 'active' : ''}`}
                onClick={() => setOpen(false)}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <Link
            href="/contact?subject=trial"
            className="btn btn-primary btn-full"
            onClick={() => setOpen(false)}
          >
            Gratis testen
          </Link>
        </div>
      )}
    </header>
  )
}
